
import { useState, useRef } from "react";
import Config from "../Config";
import InputComboGrupa from "./InputComboGrupa";
import InputTextAlpha from "./InputTextAlpha";
import InputComboStawkiWyzMulti from "./InputComboStawkiWyzMulti";
import InputCombo from "./InputCombo";




function InputEmpsMulti(props)
{
 
    
    const [filterParam, setFilterParam] = useState({
        imie: props.mainView.readFilter('imie',''), 
        nazwisko:  props.mainView.readFilter('nazwisko',''),           
    });



    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


       const [tabSelected, setTabSelected] = useState([
       
    ]);


    var clFlag = 1;
    if(props.clearFlag != null && props.clFlag != undefined) clFlag = props.clFlag;
    var [clearFlag, setClearFlag] = useState(clFlag);





   const [view, setView] = useState('btn');


    const getTab = () => {
            
        
        props.mainView.setProgress(-2);

    

        fetch( Config.url + '/rest_v1_emps,combo', {
            method: 'POST', 
            body: '', 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {                                              
                        setTab(res.result);                                         
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }


    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn'); 
    } 


    const saveData = () => {

            var selected = new Array();
            var selectedCallback = new Array();



             for(var d=0; d < tab.length; d++)
                        {
                                
                              if(tab[d].param1 == '1')  {  

                                selected.push( tab[d]);
                          
                                 selectedCallback.push( {
                                            px_group_id: tab[d].id,
                                            imie: tab[d].imie,
                                            nazwisko: tab[d].nazwisko,                                        
                                          } );  

                              };
                               
                        } 


            setTabSelected(selected);
            changeView();

            if(props.onParentsSelected != undefined) props.onParentsSelected(selectedCallback);

    }




      const valChangeListener = (filedName, val, correct, msg) => {

       //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );               
    }


    const goNextNew = () => {
        console.log("goNext");               
    }


     const goSelect = (e) => {

           var px_group_id = e.currentTarget.getAttribute('px_group_id');

            for(var k=0 ; k<tab.length; k++)
            {
                if(tab[k].id == px_group_id &&  tab[k].param1 == "1")
                {
                     tab[k].param1 = "0"
                }else 
                if(tab[k].id == px_group_id &&  tab[k].param1 == "0") tab[k].param1 = "1"
            }

          

           var s = JSON.stringify(tab);
           setTab(JSON.parse(s));  
     }



      if(tab == null)
        {
            setTab([]);
            getTab();
        

            return <div>
                ...
            </div>
        }


        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
            setTabSelected([]);
        }


        if(props.clearFlag != null && props.clearFlag != undefined)
        {
            if(props.clearFlag != clearFlag)
            {
                setClearFlag(props.clearFlag);
                setTab(null);           
                setTabSelected([]);
            }
        }


     var dlg_view = null;




 if(view != 'btn') 
     {

        //-----------------------------------------------------------

        console.log(filterParam);

        var rTab = new Array();


        for(var k=0; k<tab.length; k++) //petla po grupach..
        {
         
          
        }

        rTab = tab;
        //-----------------------------------------------------------




        var dlg_view =  (

            <div className="dlg_window dlg_type_xxx shadowx">
    
                    <div className="dlg_title">
                         Wybierz pracowników
                    </div>
    
 
                    <div className="table_filter">                       
                            <div className="filter_controll">   
                                        <label>Imię: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.imie}   valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "}   />
                           </div>  

                            <div className="filter_controll">   
                                        <label>Nazwisko: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "}   />
                            </div>  
                    </div>
    




                    <div className="dlg_content_x">
    
    
                                      <div className="xselect_multi xparents">
                                        <ul>
                                         {
                                            rTab.map( (gr, gi) => {

                                                
                                                    var css = '';
                                                   if(gr.param1 == '1') css ="selected";
                                              
                                                    return <li className={css}    px_group_id={gr.id} onClick={goSelect} >  
                                                                                    <div className="xselect_item">
                                                                                        <div className="xselect_t_title"   >{ gr.nazwisko + " " + gr.imie    } </div>                                                                                     
                                                                                    </div>                                                                                                                                                     
                                                                                
                                                                            </li>

                                            } )
                                         }
                                        </ul>
                                      </div>  
    
                                        <br/>    
                                        <br/>   
    
                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>
    
                    </div>
    
                
            </div>
    );

    }





   
    var info = '';
    var ilosc = null;


    if(tabSelected.length == 0)
    {
        info = <div onClick={changeView} className="link_bad">Nie wybrano żadnego odbiorcy</div>; ;
    }else
    {
            ilosc = <div>
                <strong>wybranych: {tabSelected.length}</strong>
            </div>
    }
    
    return  <div>

                <br/>
                <div className="btn"    onClick={changeView} >wybierz odbiorców / lista pracowników</div> 

                <div className="xselect xparents">
                    {ilosc}
                    <br/>
                        {
                            tabSelected.map( (r, ix) => {
                                return <div className="xselect_item" onClick={changeView}>
                                           <div className="xselect_t_title">{r.nazwisko} {r.imie}  </div>                                           
                                    </div>
                            } )
                        }

                        {info}

                        <br/>
                </div>


                {dlg_view} 
           </div>

}



export default InputEmpsMulti;